module.exports = {
    // toggle display of phases definition list and relevant definition list item
    // on interaction with a phase information toggle button
    init: () => {
        // get the header definition list only
        let phasesListClass = ".process_map__phases__list--has_definitions";
        let phasesList      = document.querySelector(phasesListClass);
        if (!phasesList) {
            console.error(`Could not find the list with the selector: ${phasesListClass}`);
            return;
        };
        // store this header definition list's sibling definition container
        let definitionListClass = "process_map__definitions";
        let definitionList      = phasesList.nextElementSibling;
        if (!definitionList) {
            console.error("Could not find this header definition list's sibling definition container");
            return;
        };
        // check that the sibling definition container we've stored is the correct element
        if (!definitionList.classList.contains(definitionListClass)) {
            console.error("This this header definition list is missing a sibling definition container");
        }
        // declare the class that shows the definition container
        let definitionListOpenClass = "process_map__definitions--is_visible";
        // store all of the definition list items
        let definitionListItemsClass = ".process_map__definitions__item";
        let definitionListItems      = definitionList.querySelectorAll(definitionListItemsClass);
        if (!definitionListItems) {
            console.error(`Could not find any definition list items with the selector: ${definitionListItemsClass}`);
            return;
        };
        // declare the class that shows the definition list item
        let definitionListItemActiveClass = "process_map__definitions__item--active";
        // store all of this header definition list's definition toggle buttons
        let toggleButtonsClass = ".process_map__phases__action";
        let toggleButtons      = phasesList.querySelectorAll(toggleButtonsClass);
        if (!toggleButtons) {
            console.error(`Could not find any of this header definition list's toggle buttons with the selector: ${toggleButtonsClass}`);
            return;
        };
        // declare the class that allows us to target active definition toggle buttons
        let toggleButtonsActiveClass = "process_map__phases__action--active";
        // declare the class that allows us to target active definition toggle titles
        let phaseTitleActiveClass = "process_map__phase__title--active";

        const darkerOverlayClass = ".darker";
        const darkerOverlay      = document.querySelector(darkerOverlayClass);

        // function to get value of css rule for given class
        function GetProperty (classOrId, property) {
            var FirstChar = classOrId.charAt(0);  var Remaining = classOrId.substring(1);
            var elem = (FirstChar == '#') ?  document.getElementById(Remaining) : document.getElementsByClassName(Remaining)[0];
            return window.getComputedStyle(elem, null).getPropertyValue(property);
        }

        // loop through this header definition list's toggle buttons
        toggleButtons.forEach(toggleButton => {
            // declare the name of the data attribute
            let dataID = "data-definition-id";
            // get this toggle button's ID
            let toggleButtonID = toggleButton.getAttribute(dataID);
            // listen for this button to be clicked

            toggleButton.addEventListener("click", function (event) {
                const phasesClass = ".process_map__phases";
                const phases      = document.querySelector(phasesClass);
                document.documentElement.style.overflow = "hidden";

                if (GetProperty(phasesClass, "position") === "relative") {
                    phases.style.position = "sticky";
                } else if (GetProperty(phasesClass, "position") === "sticky") {
                    phases.style.position = "relative";
                };
                if (GetProperty(phasesClass, "z-index") === "5") {
                    phases.style.zIndex = "auto";
                } else if (GetProperty(phasesClass, "z-index") === "auto") {
                    phases.style.zIndex = "5";
                };

                // remove the active class from every other button in this sub-lane
                toggleButtons.forEach(toggleButton => {
                    let phaseTitle = toggleButton.nextElementSibling;
                    phaseTitle.classList.remove(phaseTitleActiveClass);
                    toggleButton.classList.remove(toggleButtonsActiveClass);

                    // this removes --active class from phase arrow path and phase item
                    toggleButton.parentElement.parentElement.classList.remove("process_map__phases__item--active");
                    const arrow = toggleButton.parentElement.getElementsByClassName("process_map__phases__item__arrow__shadow__path");
                    arrow[0].classList.remove("process_map__phases__item__arrow__shadow__path--active");
                    // this removes darken overlay
                    darkerOverlay.classList.remove("darken");
                });

                // loop through definition list items to find one with the matching ID
                definitionListItems.forEach(definitionListItem => {
                    let listItemID = definitionListItem.getAttribute(dataID);
                    if (listItemID === toggleButtonID) {
                        // declare empty variables which will be populated later if elements are visible
                        let listIsOpen       = false;
                        let listItemIsActive = false;
                        // check if the sibling definition container is open
                        if (definitionList.classList.contains(definitionListOpenClass)) {
                            listIsOpen = true;
                        }
                        // check whether the definition list item with the matching id is already visible
                        if (definitionListItem.classList.contains(definitionListItemActiveClass)) {
                            listItemIsActive = true;
                        }
                        // if both of the above are true, remove visible class from everything in this container and all buttons in the sub-lane
                        if (listIsOpen === true && listItemIsActive === true) {
                            // remove visible class from this definition list
                            definitionList.classList.remove(definitionListOpenClass);
                            // remove visible class from all of this definition list's items
                            definitionListItems.forEach(definitionListItem => {
                                definitionListItem.classList.remove(definitionListItemActiveClass);
                            });
                        } else {
                            // if the definition container is not open, open it
                            if (listIsOpen === false) {
                                definitionList.classList.add(definitionListOpenClass);
                                definitionListItem.style.cssText = "position: fixed; overflow-y: scroll; top: 0; bottom: 0; z-index: 100";

                            }
                            // remove visible class from all definition list items
                            definitionListItems.forEach(definitionListItem => {
                                definitionListItem.classList.remove(definitionListItemActiveClass);
                            });

                            // this adds --active class to phase arrow path and phase item
                            toggleButton.parentElement.parentElement.classList.add("process_map__phases__item--active");
                            const arrow = toggleButton.parentElement.getElementsByClassName("process_map__phases__item__arrow__shadow__path");
                            arrow[0].classList.add("process_map__phases__item__arrow__shadow__path--active")

                            // this adds darken overlay
                            darkerOverlay.classList.add("darken");

                            // add the active class to this button
                            toggleButton.classList.add(toggleButtonsActiveClass);
                            let phaseTitle = toggleButton.nextElementSibling;
                            phaseTitle.classList.add(phaseTitleActiveClass);
                            // add visible class to the matching definition item
                            definitionListItem.classList.add(definitionListItemActiveClass);
                        }
                    }
                });
            }, false);
        });
    }
};
